export function renderPanelYAxis(parentElem, axis, x) {

	parentElem.append('g')
		.attr('class', 'hw_panel_graph_y_axis')
		.attr('transform', `translate(${x}, 0)`)
		.call(axis);

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-y-axis.js